import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';
import chart from './chart';
import * as d3 from 'd3';

export default {
  props: {
    value: PigeonDocNodeModel,
  },
  mounted() {
    this.createChart();
    window.addEventListener('resize', () => {
      clearTimeout(this.windowResizeTimeout);

      this.windowResizeTimeout = setTimeout(() => {
        d3.select(this.$refs['chart']).selectAll('*').remove();
        this.createChart();
      }, 1000);
    });
  },
  methods: {
    createChart() {
      chart.create(this.$refs['chart'], this.value.content.data, {
        axisLabels: this.value.meta.axisLabels,
        quadrantLabels: this.value.meta.quadrantLabels,
        axisHoverText: this.value.meta.axisHoverText,
      });
    },
  },
};
